<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="loading"
      persistent
      fullscreen
      content-class="loading-dialog"
    >
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="grey"
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AuthHandler',
  methods: mapActions(['finalizeLogin']),
  created() {
    this.redirect = this.$route.query['redirect'] || '/dashboard'

    this.finalizeLogin()
      .then(() => {
        this.$router.push(this.redirect)
      })
      .catch(error => {
        console.error('Auth handler error:', error)
        // User not authenticated, redirect to login
        this.$router.push('/login')
      })
  },
  data() {
    return {
      redirect: null,
      dialog: false,
      loading: true,
      sound: true,
      widgets: false
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: rgba($color: #fff, $alpha: 1);
}
</style>
